import { useEffect, useRef, useState } from "react";
import { FileDown } from "lucide-react";
import EmailModal from "../brochure_modal/brochure_modal";
import "./HeroTradeFloor.css";

const HERO_BACKGROUND_VIDEO =
  "https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2FWebsite%20Landing%20Video%20updated.mov?alt=media";

const APPLY_URL = "https://andus.co.za/trade-register";

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
];

const tradeFloorPillars = [
  {
    label: "Like-minded traders",
    trend: "gold",
  },
  {
    label: "World-class instructors",
    trend: "green",
  },
  {
    label: "First principles only",
    trend: "red",
  },
];

function HeroTradeFloor() {
  const videoRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [videoSrc, setVideoSrc] = useState("");
  const [isBrochureModalOpen, setIsBrochureModalOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    setVideoSrc(HERO_BACKGROUND_VIDEO);
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    if (!video || !videoSrc) return;

    video.muted = true;

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => setIsLoading(false))
        .catch((error) => {
          console.log("Autoplay blocked:", error);
          setIsLoading(false);
        });
    }
  }, [videoSrc]);

  return (
    <>
      <section
        className="trpc-tradeFloorHero"
        aria-labelledby="trpc-tradeFloorHero-title"
      >
        <div className="trpc-tradeFloorHero__frame">
          <div className="trpc-tradeFloorHero__videoContainer" aria-hidden="true">
            {isLoading && (
              <div className="trpc-tradeFloorHero__loader">
                <span />
              </div>
            )}

            <div className="trpc-tradeFloorHero__videoOverlay" />

            {videoSrc && (
              <video
                className="trpc-tradeFloorHero__video"
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onLoadedData={() => setIsLoading(false)}
                onError={() => setIsLoading(false)}
              >
                <source src={videoSrc} />
              </video>
            )}
          </div>

          <div className="trpc-tradeFloorHero__glow" aria-hidden="true" />

          <div className="trpc-tradeFloorHero__marketLayer" aria-hidden="true">
            <span className="trpc-tradeFloorHero__priceLine" />

            <div className="trpc-tradeFloorHero__candleGroup">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-tradeFloorHero__candle"
                  data-trend={trend}
                />
              ))}
            </div>
          </div>

          <div className="trpc-tradeFloorHero__content">
            <div className="trpc-tradeFloorHero__text">
              <div className="trpc-tradeFloorHero__kicker">
                TPC Trade Floors
              </div>

              <h1
                id="trpc-tradeFloorHero-title"
                className="trpc-tradeFloorHero__title"
              >
                <span>The Trade</span>
                <span>Floor</span>
              </h1>

              <p className="trpc-tradeFloorHero__lead">
                <span className="trpc-tradeFloorHero__leadDesktop">
                  Step onto TPC’s modern, vibrant trade floors. Rub shoulders with
                  like-minded traders in training, work close to world-class
                  instructors and trade from first principles — no cheap tricks,
                  only correct methodology.
                </span>

                <span className="trpc-tradeFloorHero__leadMobile">
                  Step onto TPC’s modern trade floors. Train with like-minded
                  traders, world-class instructors and first-principles
                  methodology.
                </span>
              </p>

              <ul
                className="trpc-tradeFloorHero__pillarList"
                aria-label="Trade Floor principles"
              >
                {tradeFloorPillars.map((item) => (
                  <li key={item.label} data-trend={item.trend}>
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>

              <div
                className="trpc-tradeFloorHero__buttonsRow"
                aria-label="Trade Floor actions"
              >
                <a
                  href={APPLY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="trpc-tradeFloorHero__btn trpc-tradeFloorHero__btn--primary"
                  data-candle="green"
                >
                  <span>Apply Now</span>
                </a>

                {!isBrochureModalOpen && (
                  <button
                    type="button"
                    className="trpc-tradeFloorHero__btn trpc-tradeFloorHero__btn--secondary"
                    data-candle="red"
                    onClick={() => setIsBrochureModalOpen(true)}
                    aria-label="Download the TPC Trade Floor brochure"
                  >
                    <span>Download Brochure</span>
                    <FileDown
                      className="trpc-tradeFloorHero__downloadIcon"
                      size={17}
                      strokeWidth={2.4}
                      aria-hidden="true"
                    />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <EmailModal
        isOpen={isBrochureModalOpen}
        onClose={() => setIsBrochureModalOpen(false)}
      />
    </>
  );
}

export default HeroTradeFloor;